// Dashboards (flat), ESG by-branch (flat), pilot, operations list, pickup orders, sites.

import { defineRoutes, type DemoRouteDef } from '../core';
import type { EsgDashboardPersona } from '../../types/esg-dashboard.type';
import { dashboardStatistics, pilotStatistics, wasteOutletOpsList } from '../data/dashboard';
import { esgBranchWasteExport, esgByBranch } from '../data/esg';
import { isTruthyParam, monthFromQuery } from '../data/helpers';
import { listPickupOrders } from '../data/pickupOrders';
import { collectionSitesFor } from '../data/sites';
import { str } from './errors';

const DASHBOARD_KINDS = ['waste-outlet', 'recycler', 'trucker'] as const;

export const dashboardRoutes = defineRoutes([
  ['get', '/dashboard/pilot/:orgId', (ctx) => pilotStatistics(ctx.params.orgId, monthFromQuery(ctx.query))],
  ['get', '/dashboard/operations/waste-outlets', (ctx) => wasteOutletOpsList(ctx.query)],
  ['get', '/dashboard/esg/:persona/:orgId/by-branch/export', (ctx) => esgBranchWasteExport(ctx.params.orgId)],
  [
    'get',
    '/dashboard/esg/:persona/:orgId/by-branch',
    (ctx) =>
      esgByBranch(
        ctx.params.persona as EsgDashboardPersona,
        ctx.params.orgId,
        isTruthyParam(ctx.query.all_time) ? null : monthFromQuery(ctx.query),
      ),
  ],
  ...DASHBOARD_KINDS.flatMap((kind): DemoRouteDef[] => [
    ['get', `/dashboard/${kind}/:orgId/overview`, (ctx) => dashboardStatistics(ctx.params.orgId, null)],
    ['get', `/dashboard/${kind}/:orgId`, (ctx) => dashboardStatistics(ctx.params.orgId, monthFromQuery(ctx.query))],
  ]),
  [
    'get',
    '/pickup_order',
    (ctx) => ({
      result: listPickupOrders({
        organizationId: str(ctx.query.organization_id) ?? ctx.orgId,
        start: str(ctx.query.start_date),
        end: str(ctx.query.end_date),
        status: str(ctx.query.status),
        page: ctx.query.page,
        limit: ctx.query.limit,
        sortBy: str(ctx.query.sort_by),
        sortDirection: str(ctx.query.sort_pickup_order),
      }),
    }),
  ],
  ['get', '/collection_site/:orgId', (ctx) => ({ result: collectionSitesFor(ctx.params.orgId) })],
]);
